module.exports = __webpack_public_path__ + "img/main_menu_3.2bdd8161.png";